import { Circle } from '@mui/icons-material';
import { Box } from '@mui/material';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

import { MobileCaption } from '../Typography';

export type StatusLightType =
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'default';

const TYPE_COLORS: Record<StatusLightType, string> = {
  success: BASE_COLORS.green,
  warning: BASE_COLORS.yellow,
  error: BASE_COLORS.red,
  info: BASE_COLORS.blue,
  default: BASE_COLORS.gray,
};

export interface StatusLightProps {
  type: StatusLightType;
  size?: number;
  label?: string;
  sx?: object;
}

const StatusLight: React.FC<StatusLightProps> = ({
  type,
  size = 12,
  label,
  sx,
}) => {
  const color = TYPE_COLORS[type] ?? TYPE_COLORS.default;
  const hasLabel = label != null && label !== '';

  if (hasLabel) {
    return (
      <Box
        component="span"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          ...sx,
        }}
      >
        <MobileCaption
          component="span"
          sx={{ color: 'text.secondary', fontWeight: 400 }}
        >
          {label}
        </MobileCaption>
        <Circle
          sx={{
            color,
            fontSize: `${size}px`,
            fontWeight: 'bold',
            flexShrink: 0,
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Circle
        sx={{
          color,
          fontSize: `${size}px`,
          fontWeight: 'bold',
        }}
      />
    </Box>
  );
};

export default StatusLight;
